import React, { Component } from "react";
import { View, TouchableWithoutFeedback, StyleSheet, FlatList, Dimensions, TouchableOpacity } from "react-native";
import TextView from "./TextView";
import {wp} from "../utils/responsive";

var { width, height } = Dimensions.get('window');

class DialogList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: props.show,
            data: props.data,
            selected: '',

        }
        this.onClose = this.onClose.bind(this)
    }

    onClose() {
        this.setState({
            show: false
        })
        this.props.onCancel()
    }
    onSelect(item, index) {
        this.setState({
            show: false,
            selected: item,
        })
        this.props.onSelect(item, index)
    }
    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <TouchableOpacity style={styles.itemWraper} onPress={() => {
            this.onSelect(item, index)
        }}>
            <TextView style={styles.item}>{item[this.props.field]}</TextView>

        </TouchableOpacity>;
    }
    render() {
        return (
            this.state.show?<TouchableWithoutFeedback onPress={() => {
                    this.onClose()

                }}>
                    <View style={styles.modalAbsolute} >
                        <TouchableWithoutFeedback onPress={() => {


                        }}>
                            <View style={styles.modalContent}>
                                <TextView style={{ fontSize: 20, marginBottom: 5 }}>{this.props.title}</TextView>
                                <FlatList
                                    data={this.state.data}
                                    style={{ width: width - 100 }}
                                    keyExtractor={this._keyExtractor}
                                    renderItem={this.renderRow.bind(this)}
                                />
                            </View>
                        </TouchableWithoutFeedback>
                    </View>
                </TouchableWithoutFeedback>:<View/>
        );
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            show: newprops.show,
            data: newprops.data
        })
    }
}

const styles = StyleSheet.create({
    modalAbsolute: {
        width: wp(100),
        height: height,
        position: 'absolute',
        backgroundColor: '#00000066',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: 10,
        width: wp(100) - 100,
        padding: 10,
        alignSelf:'center',
        maxHeight: height - 100,
        justifyContent: 'center',
        alignItems: 'center'
    },
    itemWraper: {
        padding: 10
    },
    item: {
        textAlign: 'center'
    }

});
export default DialogList;
